import {
    FilePickerItem_ModifiedByAriaText,
    FilePickerItem_LastModifiedAriaText,
    FilePickerItem_FolderAriaText,
    FilePickerItem_FileAriaText,
} from './getAriaLabelForFileProviderItem.locstring.json';
import loc, { format, isStringNullOrWhiteSpace } from 'owa-localize';
import { formatUserDate } from 'owa-datetime';
import FileProviderItemViewState, {
    FileProviderItemType,
} from '../../store/schema/FileProviderItemViewState';

function getModifiedAriaString(item: FileProviderItemViewState): string {
    if (!item.modifiedTime) {
        return null;
    }

    const modifiedTime = formatUserDate(item.modifiedTime);

    if (!isStringNullOrWhiteSpace(item.modifiedBy)) {
        return format(loc(FilePickerItem_ModifiedByAriaText), item.modifiedBy, modifiedTime);
    } else {
        return format(loc(FilePickerItem_LastModifiedAriaText), modifiedTime);
    }
}

export default function getAriaLabelForFileProviderItem(item: FileProviderItemViewState): string {
    const ariaStringToUse =
        item.type === FileProviderItemType.Folder
            ? loc(FilePickerItem_FolderAriaText)
            : loc(FilePickerItem_FileAriaText);
    const modifiedAriaText = getModifiedAriaString(item);
    const ariaLabel = modifiedAriaText
        ? format(ariaStringToUse, item.name, modifiedAriaText)
        : item.name;

    return ariaLabel;
}
